import { h } from 'preact'

export const SeoKeywords = (props) => {
   const { title, keywords, cacheKey } = props
   return (
      <div class="bg-gray2" id="zone_seo_keywords" data-testid="bande-seo" data-cache-key={cacheKey}>
         <div class="container-fluid">
            <div class="row no-gutters py-1 text-black">
               <div class="col-12">
                  {title !== '' ? <strong class="lead font-weight-bold d-block">{title}</strong> : null}
                  <div class="small">{keywords}</div>
               </div>
            </div>
         </div>
      </div>
   )
}
